import { render } from "./DeliveryEnd.vue?vue&type=template&id=2d1766cb"
import script from "./DeliveryEnd.vue?vue&type=script&lang=js"
export * from "./DeliveryEnd.vue?vue&type=script&lang=js"
script.render = render

export default script